module.exports = __webpack_public_path__ + "img/logo_eleva.2ef0640b.png";